
window.addEventListener('DOMContentLoaded', function () {
    console.log('scrollable');
    new ScrollHint('.js-scrollable', {
      scrollHintIconAppendClass: 'scroll-hint-icon-white', 
      suggestiveShadow: true,
      i18n: {
        scrollable: "スクロールできます"
      }
    });
  });